
import { memone, MutableRecordStore, MutableSetStore } from '@deqo/foundation';
import { HangoutClient } from './HangoutClient';
import { HangoutUser } from './HangoutUser';

const template = {
    clients: new Set<HangoutClient>(),
    users: new Set<HangoutUser>(),
};

export class HangoutLocation extends MutableRecordStore(template) {

    public readonly name?: string;
    public readonly param?: string;

    constructor(public readonly path: string) {
        super();
        if (path) {
            const [last] = path.split('/').reverse();
            const [a, b] = last.split(':');
            this.name = a;
            this.param = b;
        }
    }

    public test(pattern: string) {
        pattern = pattern.replace(/\*/g, '.*');
        const r = new RegExp(`^${pattern}$`);
        return r.test(this.path);
    }
}

export class HangoutLocationStore extends MutableSetStore<HangoutLocation> {

    public get(id: string) {
        return this.getMemoizedIndex(this.state).get(id) || null;
    }

    public reset() {
        this.mutateTo(new Set());
    }

    @memone()
    private getMemoizedIndex(state: Set<HangoutLocation>) {
        const index = new Map<string, HangoutLocation>();
        for (const x of state) {
            index.set(x.path, x);
        }
        return index;
    }
}
